import React from 'react';
import styled from 'styled-components';

import GroupCards from './GroupCards';

const GroupListContainer = styled.div``;

const BodyContainer = styled.div`
    display: flex;
    flex-direction: column;
    gap: 24px;
    width: 100%;
    height: fit-content;
`;

const TeamSetUpTable = ({ teamList = [], handleEditTeamButtonClick, handleAddTeam, review = false }) => {
    return (
        <GroupListContainer>
            <BodyContainer>
                <GroupCards
                    teamList={teamList}
                    handleEditTeamButtonClick={handleEditTeamButtonClick}
                    handleAddTeam={handleAddTeam}
                    editOption={!review}
                />
            </BodyContainer>
        </GroupListContainer>
    );
};

export default TeamSetUpTable;
